import BulkOrderCardDesignsIndexPage from '../../../components/pages/bulk_order/card_designs/BulkOrderCardDesignsIndexPage'
export default {
  components: { BulkOrderCardDesignsIndexPage }
}
